import React from "react";

export default function Footer() {
  return (
    <div className="footer_wrapper">
      <div className="porch_border">
        <h1>Porch</h1>
        <div className="footer_links">
          <p>Home</p>
          <p>Menu</p>
          <p>Gallery</p>
          <p>About</p>
          <p>Contact Us</p>
        </div>
        <div className="footer_btn">
          <div className="address">Food license FSSAI: 20240229105705860</div>
          <div className="order_online">
            <button>Order Online</button>
            <button>Reserve</button>
          </div>
        </div>
      </div>
      <div className="footer_time">
        <p>Monday-Friday;11am-8:30|Saturday-Sunday;11:30am-10pm </p>
      </div>
    </div>
  );
}
